export default __webpack_public_path__ + "static/nav-portugal-68c5796b0d546fcfd538df72acf0a21f.png";